function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="16" height="30" viewBox="0 0 16 30" {...props}><path d="M15.804 7.821c.214.238.256.5.125.786L6.286 29.268c-.154.297-.404.446-.75.446-.047 0-.13-.012-.25-.036a.757.757 0 0 1-.455-.339.681.681 0 0 1-.08-.536L8.27 14.374l-7.25 1.804a.94.94 0 0 1-.214.018A.833.833 0 0 1 .251 16c-.214-.179-.291-.41-.232-.696L3.61.572a.763.763 0 0 1 .285-.411.811.811 0 0 1 .5-.161h5.857c.226 0 .417.074.571.223a.707.707 0 0 1 .232.527.73.73 0 0 1-.089.321L7.911 9.339l7.071-1.75a.971.971 0 0 1 .214-.036c.226 0 .429.09.607.268h.001z" /></svg>;
});